import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';
import { Box, Typography, Grid, Paper } from '@mui/material';

const NeurologicalRehabilitation = () => {
  const serviceData = {
    title: "Neurological Rehabilitation",
    image: "/neuro.png",
    description: "Our neurological rehabilitation program provides specialized care for patients with neurological conditions. We focus on improving function, mobility, and quality of life through evidence-based treatment approaches.",
    benefits: [
      "Improved movement control",
      "Enhanced balance and coordination",
      "Better daily function",
      "Increased independence",
      "Reduced complications",
      "Enhanced quality of life"
    ],
    approach: [
      "Comprehensive neurological assessment",
      "Individualized treatment planning",
      "Advanced therapeutic techniques",
      "Functional training",
      "Family education",
      "Progress monitoring"
    ],
    additionalContent: (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Treatment Programs
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: "Stroke Rehabilitation",
              description: "Specialized programs to help recover function and independence after stroke."
            },
            {
              title: "Movement Disorders",
              description: "Treatment for conditions like Parkinson's disease and multiple sclerosis."
            },
            {
              title: "Brain Injury Recovery",
              description: "Comprehensive rehabilitation for traumatic and acquired brain injuries."
            }
          ].map((program, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,150,136,0.15)'
                  }
                }}
              >
                <Typography variant="h6" gutterBottom color="primary">
                  {program.title}
                </Typography>
                <Typography variant="body2">
                  {program.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  };

  return <ServiceLayout {...serviceData} />;
};

export default NeurologicalRehabilitation; 